import type { Position } from 'geojson';
import hasSelfIntersection from '../hasSelfIntersection';

type Args = {
  committedCoordinates: Array<Position>;
  nextPoint: Position;
};

/**
 * Returns true when adding `nextPoint` to the in-progress ring would produce
 * a self-intersecting polygon (including the closing edge back to the start).
 */
const wouldNextPointSelfIntersect = ({
  committedCoordinates,
  nextPoint,
}: Args): boolean => {
  if (committedCoordinates.length < 2) {
    return false;
  }

  const [start] = committedCoordinates;
  if (!start) {
    return false;
  }

  return hasSelfIntersection({
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [[...committedCoordinates, nextPoint, start]],
    },
  });
};

export default wouldNextPointSelfIntersect;
